/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { StorageTypeList01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const storageTypeList01ResetTimestamp = (
  state,
  { currentPage, sorts, filters, pageSize }
) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  toStorageTypeOptions: INITIAL_STATE.toStorageTypeOptions,
  toStorageTypeOption: INITIAL_STATE.toStorageTypeOption
});

export const storageTypeList01FetchStorageTypeList01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const storageTypeList01FetchStorageTypeList01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const storageTypeList01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const storageTypeList01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const storageTypeList01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const storageTypeList01UploadLoading = (state, { boolean }) => ({
  ...state,
  uploadIsLoading: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [StorageTypeList01Types.STORAGE_TYPE_LIST01_RESET_TIMESTAMP]: storageTypeList01ResetTimestamp,
  [StorageTypeList01Types.STORAGE_TYPE_LIST01_FETCH_STORAGE_TYPE_LIST01_LOADING]: storageTypeList01FetchStorageTypeList01Loading,
  [StorageTypeList01Types.STORAGE_TYPE_LIST01_FETCH_STORAGE_TYPE_LIST01_SUCCESS]: storageTypeList01FetchStorageTypeList01Success,
  [StorageTypeList01Types.STORAGE_TYPE_LIST01_ADD_SELECTED_DOCUMENTS]: storageTypeList01AddSelectedDocuments,
  [StorageTypeList01Types.STORAGE_TYPE_LIST01_REMOVE_SELECTED_DOCUMENTS]: storageTypeList01RemoveSelectedDocuments,
  [StorageTypeList01Types.STORAGE_TYPE_LIST01_SET_WORKSPACE_VISIBLE]: storageTypeList01SetWorkspaceVisible,

  [StorageTypeList01Types.STORAGE_TYPE_LIST01_UPLOAD_LOADING]: storageTypeList01UploadLoading
});
